import React from 'react';
import TextField from '@mui/material/TextField';

export default function AddressAutocomplete({ label, value, onChange, ...props }) {
  // Temporarily disable API: simple text input only
  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      {...props}
    />
  );
}
